module.exports = __webpack_public_path__ + "logo_org.png?6502312f686eb12c4ea19a69960e9587";


//////////////////
// WEBPACK FOOTER
// ./src/logo_org.png
// module id = 35
// module chunks = 0